import React, { useState, useEffect } from "react";
import { Icon, Image, Grid, GridRow, GridColumn } from "semantic-ui-react";
import { ENV, buildStorageUrl } from "../../../../../../utils";
import "../TemplateManager.scss";

export const Smu05 = React.memo((props) => {
  const { slideId, activeSession } = props;
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState("");

  /**
   * Updates the component state with the content of the selected slide in Smu05.js.
   *
   * This `useEffect` hook is triggered whenever the `slideId` changes. It searches the `activeSession.slides`
   * array for a slide that matches the `slideId`. If such a slide is found and it contains content, the hook
   * updates the component's state with the slide's title, content, and image URL.
   *
   * Specifically, it performs the following actions:
   * - Sets the `title` state with the slide's content title.
   * - Sets the `content` state with the slide's content.
   * - Sets the `image` state with the slide's content image URL.
   *
   * This ensures that the component reflects the content of the currently selected slide, displaying the title,
   * content, and image in a user-friendly format. This is crucial for maintaining user engagement and providing
   * a visually appealing interface.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setTitle(slide.content.title);
      setContent(slide.content.content);
      setImage(slide.content.image);
    }
  }, [slideId]);

  return (
    <div className="column">
      <h3 className="show-slide__title">
        <Icon name="bookmark" />
        {title}
      </h3>
      <div className="show-slide__body">
        <Grid columns={2} divided>
          <GridRow>
            <GridColumn>
              <Image bordered rounded fluid src={buildStorageUrl(image)} />
            </GridColumn>
            <GridColumn>
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </GridColumn>
          </GridRow>
        </Grid>
      </div>
    </div>
  );
});
